// it is in separate import because you can't insert code between imports
import cuckoo from "../../services/cuckoo/cuckoo"
import { cuckooEvents } from "../../consts/enums"
import * as perfTracker from "../../utils/perfTracker"

perfTracker.onBeforeImport()

cuckoo.track(cuckooEvents.GENERAL_PAGE_PARSING, {
  timeFromBegin: perfTracker.getBeginToBeforeImportDuration(),
})
